import { FilterResponse } from '../api/filter';
import { Filter } from '../models/filter';

export const FILTER_NAMES: Record<string, string> = {
  meat_type: '분류',
  meat_loin: '품목',
  origin: '원산지',
  brand: '브랜드',
  grade: '등급',
  warehouse: '창고',
  storage_type: '보관',
  EST: 'EST',
  company: '판매자',
};

export const mapFilterApiToModel = (data: FilterResponse): Filter[] => {
  return Object.entries(data.filters)
    .filter(([key]) => key in FILTER_NAMES)
    .map(([key, values]) => ({
      id: key,
      name: FILTER_NAMES[key],
      options: values.map((value: string) => ({
        name: value,
        selected: false,
      })),
    }));
};
